export class RestoreDynamoDBToS3Request {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "s3Bucket",
            "baseName": "s3Bucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "s3Prefix",
            "baseName": "s3Prefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "outputFormat",
            "baseName": "outputFormat",
            "type": "DynamoDBRestoreToS3OutputFormat",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreDynamoDBToS3Request.attributeTypeMap;
    }
    constructor() {
    }
}
